exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DeleteEligibilityConfirmation_Caution_k78ct {\n    color: red;\n    fontSize:16px;\n    paddingBottom: 5px;\n}\n\n.DeleteEligibilityConfirmation_Section_2YLQH {\n    width: 50%;\n}\n\n.DeleteEligibilityConfirmation_SectionTitle_3tAp6 {\n    padding-bottom: 5px;\n    font-weight: bolder;\n    color: #660000;\n}\n\n.DeleteEligibilityConfirmation_ButtonDiv_RFtmT {\n    display: flex;\n    justify-content: center;\n}\n\n.DeleteEligibilityConfirmation_EligSection_24NhS {\n    display: flex;\n    flexFlow: row;\n    width: 100%\n}", ""]);

// Exports
exports.locals = {
	"Caution": "DeleteEligibilityConfirmation_Caution_k78ct",
	"Section": "DeleteEligibilityConfirmation_Section_2YLQH",
	"SectionTitle": "DeleteEligibilityConfirmation_SectionTitle_3tAp6",
	"ButtonDiv": "DeleteEligibilityConfirmation_ButtonDiv_RFtmT",
	"EligSection": "DeleteEligibilityConfirmation_EligSection_24NhS"
};